import React from "react";
import { useSaveBarState } from "../../context/SaveBarContext";
import { useIsNarrow } from "../../context/LayoutContext";
import useUnsavedChangesGuard from "../../hooks/useUnsavedChangesGuard";
import LoadingButton from "./LoadingButton";

// Sticky amber save-bar onderaan (left = sidebar-breedte), zichtbaar bij onopgeslagen wijzigingen.
export default function SaveBar() {
  const ctx = useSaveBarState();
  // De balk staat buiten .app-shell in de DOM, dus de uitlijning kan niet uit een
  // CSS-afstammelingsselector komen: in drawer-modus schuift hij naar links 0.
  const isNarrow = useIsNarrow();
  const visible = !!ctx?.entry && ctx.entry.count > 0;
  // Zichtbare balk = niet-opgeslagen wijzigingen: de shell vraagt dan bevestiging vóór
  // navigeren en de browser vóór sluiten/herladen.
  useUnsavedChangesGuard(visible);
  if (!visible) return null;
  const { count, saving } = ctx.entry;

  return (
    <div
      className="save-bar"
      role="region"
      aria-label="Niet-opgeslagen wijzigingen"
      style={{
        position: "fixed",
        left: isNarrow ? 0 : "var(--sidebar-width)",
        right: 0,
        bottom: 0,
        zIndex: "var(--z-sticky)",
        background: "var(--color-warn-bg)",
        borderTop: "1px solid var(--color-warn-border)",
        boxShadow: "0 -4px 12px rgba(0,0,0,.06)",
        padding: "12px var(--main-pad-x)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      <div aria-live="polite" style={{ fontSize: "13.5px", fontWeight: 600, color: "var(--color-warn-text)" }}>
        {count === 1 ? "1 niet-opgeslagen wijziging" : `${count} niet-opgeslagen wijzigingen`}
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          type="button"
          onClick={ctx.discard}
          disabled={saving}
          style={{
            border: "1px solid var(--color-warn-border)",
            background: "var(--color-surface)",
            borderRadius: "var(--radius-md)",
            padding: "8px 14px",
            fontSize: "13px",
            fontWeight: 600,
            color: "var(--color-warn-text)",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Verwerpen
        </button>
        <LoadingButton
          onClick={ctx.save}
          loading={saving}
          style={{
            background: "var(--color-primary-600)",
            color: "var(--color-surface)",
            border: "none",
            borderRadius: "var(--radius-md)",
            padding: "8px 16px",
            fontSize: "13px",
            fontWeight: 600,
          }}
        >
          Opslaan
        </LoadingButton>
      </div>
    </div>
  );
}
